import { Box } from '@mui/material';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import PropTypes from 'prop-types';
import React from 'react';
import { styled } from '@mui/system';

export const PAGING_RAIL_WIDTH = 40;

const RailButton = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.disabled': {
    cursor: 'default',
    opacity: 0.25,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '4rem',
    pointerEvents: 'none',
  },
}));

export default function PagingRail(props) {
  const { side, disabled, onClick } = props;
  const label = side === 'left' ? 'Previous page' : 'Next page';

  return (
    <Box sx={{
      flex: `0 0 ${PAGING_RAIL_WIDTH}px`,
      display: { xs: 'none', sm: 'flex' },
      alignItems: 'stretch',
    }}>
      <RailButton
        className={disabled ? 'disabled' : ''}
        onClick={disabled ? undefined : onClick}
        aria-label={label}
      >
        {side === 'left' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </RailButton>
    </Box>
  );
}

PagingRail.propTypes = {
  side: PropTypes.oneOf(['left', 'right']).isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
